var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "slide-from-left" } }, [
    _vm.show
      ? _c(
          "div",
          { staticClass: "SideMenu__Component", style: { width: _vm.width } },
          [_vm._t("default")],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }